let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fQV6S")).then(() => parcelRequire('iFZnT'));